
const defaultProdConfig = {
  // baseUrl: "https://sxhjmj2hy5.execute-api.us-east-1.amazonaws.com",
  // socketUrl: "wss://qcjpvdmyai.execute-api.us-east-1.amazonaws.com/development/",
  baseUrl: "https://oseia5gh4d.execute-api.us-east-1.amazonaws.com",
  socketUrl: "wss://l54gqmhda7.execute-api.us-east-1.amazonaws.com/dev"
}

const backend = {
  apiPath: "",
  devBaseURL: import.meta.env.VITE_API_URL as string || defaultProdConfig.baseUrl,
  prodBaseURL: import.meta.env.VITE_API_URL as string || defaultProdConfig.baseUrl,
  wsUrl: import.meta.env.VITE_SOCKET_URL as string || defaultProdConfig.socketUrl,
} as const

export default backend
